"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerModelManager = exports.ClientModelManager = exports.ModelManager = void 0;
var tslib_1 = require("tslib");
var history_1 = require("./model/history/base/history");
var model_manipulator_1 = require("./model/manipulators/model-manipulator");
var ModelManager = (function () {
    function ModelManager(model, options, batchUpdatableObject) {
        this.model = model;
        this.richOptions = options;
        this.modelManipulator = new model_manipulator_1.ModelManipulator(this, batchUpdatableObject);
        this.history = new history_1.History(options.control);
    }
    return ModelManager;
}());
exports.ModelManager = ModelManager;
var ClientModelManager = (function (_super) {
    tslib_1.__extends(ClientModelManager, _super);
    function ClientModelManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ClientModelManager.prototype, "clientMode", {
        get: function () { return true; },
        enumerable: false,
        configurable: true
    });
    return ClientModelManager;
}(ModelManager));
exports.ClientModelManager = ClientModelManager;
var ServerModelManager = (function (_super) {
    tslib_1.__extends(ServerModelManager, _super);
    function ServerModelManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ServerModelManager.prototype, "clientMode", {
        get: function () { return false; },
        enumerable: false,
        configurable: true
    });
    return ServerModelManager;
}(ModelManager));
exports.ServerModelManager = ServerModelManager;
